import React, { useEffect, useState, useCallback } from "react";
import styled from "styled-components";
import { Tooltip } from "antd";

import LeftSidePanel from "../leftPanelContent/LeftSidePanel";
import AmeaButtons from "./AmeaButtons";
import RightSidePanel from "../rightPanelContent/RightSidePanel";
import MapAMEA from "../smartiscity/MapAMEA";
import ViewModal from "./ViewModal";
import * as Icon from "../smartiscity/Icons";

const MapContainer = ({
  data,
  loading = false,
  categoryId,
  selectedCategory,
  showNewRouteForm,
  refresh,
}) => {
  const [showRightSide, setShowRightSide] = useState(false);
  const [showLeftSide, setShowLeftSide] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedRoute, setSelectedRoute] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [randomNumber, setRandomNumber] = useState(3213);
  const [showInfrastructuresOnNewRoute, setShowInfrastructuresOnNewRoute] =
    useState(true);

  const onCloseModal = useCallback(() => setShowModal(false), []);
  const handleLeftSide = useCallback((value) => setShowLeftSide(value), []);
  const resetSelectedItem = useCallback(() => {
    setSelectedItem(null);
    setShowRightSide(false);
  }, []);

  const getRandomNumber = useCallback(() => {
    setRandomNumber(Math.floor(Math.random() * 1000));
  }, []);

  useEffect(() => {
    // setShowRightSide(false);
    // setSelectedItem(null);
    resetSelectedItem();
  }, [categoryId, selectedCategory.get]);

  useEffect(() => {
    showNewRouteForm.set((prevState) => prevState);
  }, [selectedCategory.get, showNewRouteForm]);

  useEffect(() => {
    getRandomNumber();
  }, [
    categoryId,
    selectedCategory.get,
    showNewRouteForm.get,
    refresh,
    data,
    getRandomNumber,
  ]);

  useEffect(() => {
    if (selectedCategory.get === "routes" && data.length > 0) {
      setSelectedRoute(data[0]);
    }
  }, [data, selectedCategory.get]);

  const mapKey =
    categoryId === "122"
      ? `${selectedCategory.get}_${randomNumber}`
      : `other_${categoryId ?? "other"}_${randomNumber}`;

  return (
    <Container>
      <LeftSidePanel
        data={data}
        loading={loading}
        selectedItem={{ getItem: selectedItem, setItem: setSelectedItem }}
        rightSideBox={{
          isVisible: showRightSide,
          setIsVisible: setShowRightSide,
        }}
        categoryId={categoryId}
        selectedCategory={selectedCategory.get}
        handleLeftSide={handleLeftSide}
        showNewRouteForm={showNewRouteForm}
        refreshComponent={refresh}
        refreshMap={getRandomNumber}
      />
      {categoryId === "122" && !showNewRouteForm.get && (
        <AmeaButtons
          selectedCategory={selectedCategory}
          visibleRightSide={showRightSide}
          visibleLeftSide={showLeftSide}
          resetSelectedItem={resetSelectedItem}
        />
      )}
      <div
        style={{
          width: "30px",
          height: "30px",
          backgroundColor: "red",
          position: "absolute",
        }}
      ></div>
      {categoryId === "122" &&
        selectedCategory.get === "routes" &&
        !showNewRouteForm.get && (
          <Tooltip title="Νέα Διαδρομή" placement="left">
            <NewRoute
              $showNewRoute={showNewRouteForm.get}
              onClick={() => {
                const userToken = localStorage.getItem("userToken");
                if (userToken) {
                  showNewRouteForm.set(true);
                } else {
                  setShowModal(true);
                }
              }}
            >
              <img src={Icon.addCircle} alt="Add new route" />
            </NewRoute>
          </Tooltip>
        )}
      <MapAMEA
        key={mapKey}
        selectedItem={{ getItem: selectedItem, setItem: setSelectedItem }}
        selectedRoute={selectedRoute}
        rightSideBox={{
          isVisible: showRightSide,
          setIsVisible: setShowRightSide,
        }}
        data={data}
        showNewRoute={showNewRouteForm.get}
        selectedCategory={selectedCategory.get}
        categoryId={categoryId}
        showInfrastructuresOnNewRoute={showInfrastructuresOnNewRoute}
      />
      <RightSidePanel
        showRightSide={{ get: showRightSide, set: setShowRightSide }}
        selectedItem={selectedItem}
        categoryId={categoryId}
        selectedCategory={selectedCategory.get}
      />
      {categoryId === "122" && (
        <ViewModal
          modalStatus={showModal}
          title={null}
          closeModal={onCloseModal}
        >
          <ModalContainer>
            <ModalText>
              Για να δημιουργήσετε την δικής σας διαδρομή, παρακαλούμε
              συνδεθείτε στον λαγαριασμό σας
            </ModalText>
            <NewRouteButton
              type="primary"
              onClick={() => {
                localStorage.setItem("redirectPath", window.location.pathname);
                window.location.href = `https://amea-ampel-cms.dotsoft.gr/oauth/authorize?client_id=a0qEic7h0fWT3034AOz8q57IfUXKVBPw&redirect_uri=http://localhost:3000/callback&scope=citizen&response_type=code`;
              }}
            >
              Σύνδεση
            </NewRouteButton>
          </ModalContainer>
        </ViewModal>
      )}
    </Container>
  );
};

export default MapContainer;

const Container = styled.div`
  padding-top: 70px;
  position: relative;
`;

const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  padding-block: 30px;
  justify-content: center;
  align-items: center;
`;

const ModalText = styled.p`
  text-align: center;
  width: 400px;
  margin: 0 auto;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.5%;
`;

const NewRoute = styled.div`
  position: absolute;
  top: ${(props) => (props.$showNewRoute ? "110px" : "130px")};
  right: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
  box-shadow: 0 0 8px 2px rgba(0, 0, 0, 0.1);
  width: 40px;
  height: 40px;
  background: #27aae1;
  border-radius: 4px;
  &:hover {
    background-color: #4bc7fa;
  }
  transition: all 0.5s ease;
`;

const NewRouteButton = styled.button`
  border-radius: 12px;
  background-color: #27aae1;
  width: fit-content;
  height: fit-content;
  padding: 10px 16px;
  color: #000;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
  &:hover {
    background-color: #4bc7fa;
  }
  transition: all 0.6s ease;
`;

// import classes from "./MapContainer.module.css";
// import React, { useEffect, useState } from "react";

// import LeftSidePanel from "../leftPanelContent/LeftSidePanel";
// import AmeaButtons from "./AmeaButtons";
// import RightSidePanel from "../rightPanelContent/RightSidePanel";
// import AmeaFilters from "./AmeaFilters";
// import MapAMEA from "../smartiscity/MapAMEA";
// import styled from "styled-components";
// import { Tooltip } from "antd";
// import AddCircle from "../../../../SMARTCITY/assets/svg/components/AddCircle";
// import ViewModal from "./ViewModal";
// import "./ViewModal.css";
// import * as Icon from "../smartiscity/Icons";
// import Spiderfy from "../smartiscity/Spiderfy";

// let listener = null;
// const MapContainer = ({
//   data,
//   loading = false,
//   categoryId = "122",
//   selectedCategory,
//   showNewRouteForm,
//   refresh,
// }) => {
//   const [showRightSide, setShowRightSide] = useState(false);
//   const [showLeftSide, setShowLeftSide] = useState(false);
//   const [selectedItem, setSelectedItem] = useState(null);
//   const [selectedRoute, setSelectedIRoute] = useState(null);
//   const [showModal, setShowModal] = useState(false);
//   const [randomNumber, setRandomNumber] = useState(3213);
//   // const [showNewRouteForm, setShowNewRouteForm] = useState(false);

//   const onCloseModal = () => {
//     setShowModal(false);
//   };

//   const handleLeftSide = (value) => {
//     setShowLeftSide(value);
//   };

//   const resetSelectedItem = () => {
//     setSelectedItem(null);
//     setShowRightSide(false);
//   };

//   useEffect(() => {
//     showNewRouteForm.set((prevState) => prevState);
//   }, [selectedCategory.get]);

//   const getRandomNumber = () => {
//     const randomNumber = Math.floor(Math.random() * 1000);
//     setRandomNumber(randomNumber);
//   };

//   useEffect(() => {
//     getRandomNumber();
//   }, [categoryId, selectedCategory.get, showNewRouteForm, refresh, data]);

//   useEffect(() => {
//     if (selectedCategory.get === "routes") {
//       console.log("TEST setting route,", data);
//       setSelectedIRoute(data[0]);
//     }
//   }, [data]);
//   // const getMap = (data, key) => {
//   //   const randomNumber = Math.floor(Math.random() * 1000);
//   //   return (
//   //     <MapAMEA
//   //       key={
//   //         showNewRouteForm.get ? "new-route-infra" : `${key}_${randomNumber}`
//   //       }
//   //       selectedItem={{ getItem: selectedItem, setItem: setSelectedItem }}
//   //       rightSideBox={{
//   //         isVisible: showRightSide,
//   //         setIsVisible: setShowRightSide,
//   //       }}
//   //       data={data}
//   //       showNewRoute={showNewRouteForm.get}
//   //       selectedCategory={selectedCategory.get}
//   //       categoryId={categoryId}
//   //     />
//   //   );
//   // };

//   return (
//     <div style={{ paddingTop: "70px", position: "relative" }}>
//       <LeftSidePanel
//         data={data}
//         loading={loading}
//         selectedItem={{ getItem: selectedItem, setItem: setSelectedItem }}
//         rightSideBox={{
//           isVisible: showRightSide,
//           setIsVisible: setShowRightSide,
//         }}
//         categoryId={categoryId}
//         selectedCategory={selectedCategory.get}
//         handleLeftSide={handleLeftSide}
//         showNewRouteForm={{
//           ...showNewRouteForm,
//         }}
//         refreshComponent={refresh}
//         refreshMap={getRandomNumber}
//       />
//       {categoryId === "122" && !showNewRouteForm.get && (
//         <AmeaButtons
//           selectedCategory={selectedCategory}
//           visibleRightSide={showRightSide}
//           visibleLeftSide={showLeftSide}
//           resetSelectedItem={resetSelectedItem}
//         />
//       )}

//       {/* ============== */}
//       {/* {categoryId === "122" &&
//         (selectedCategory.get === "infra" || showNewRouteForm) && (
//           <AmeaFilters refreshComponent={refresh} />
//         )} */}
//       {categoryId === "122" &&
//         selectedCategory.get === "routes" &&
//         !showNewRouteForm.get && (
//           <Tooltip title="Νέα Διαδρομή" placement="left">
//             <NewRoute
//               $showNewRoute={showNewRouteForm.get}
//               onClick={() => showNewRouteForm.set(true)}
//             >
//               <img src={Icon.addCircle} />
//             </NewRoute>
//           </Tooltip>
//         )}
//       {/* ============== */}

//       <MapAMEA
//         key={
//           categoryId === "122"
//             ? `${selectedCategory.get}_${randomNumber}`
//             : `other_${categoryId ?? "other"}_${randomNumber}`
//         }
//         selectedItem={{ getItem: selectedItem, setItem: setSelectedItem }}
//         selectedRoute={selectedRoute}
//         rightSideBox={{
//           isVisible: showRightSide,
//           setIsVisible: setShowRightSide,
//         }}
//         data={data}
//         showNewRoute={showNewRouteForm.get}
//         selectedCategory={selectedCategory.get}
//         categoryId={categoryId}
//       />

//       <RightSidePanel
//         showRightSide={{ get: showRightSide, set: setShowRightSide }}
//         selectedItem={selectedItem}
//         categoryId={categoryId}
//         selectedCategory={selectedCategory.get}
//       />
//       {categoryId === "122" && (
//         <ViewModal
//           modalStatus={showModal}
//           title={null}
//           closeModal={onCloseModal}
//         >
//           <ModalContainer>
//             <p
//               style={{
//                 textAlign: "center",
//                 width: "400px",
//                 margin: "0 auto",
//                 fontSize: "16px",
//                 fontWeight: "400",
//                 lineHeight: "24px",
//                 letterSpacing: "0.5%",
//               }}
//             >
//               Για να δημιουργήσετε την δικής σας διαδρομή, παρακαλούμε
//               συνδεθείτε στον λαγαριασμό σας
//             </p>
//             <NewRouteButton type="primary">Σύνδεση</NewRouteButton>
//           </ModalContainer>
//         </ViewModal>
//       )}
//     </div>
//   );
// };

// export default MapContainer;

// const ModalContainer = styled.div`
//   display: flex;
//   flex-direction: column;
//   gap: 30px;
//   padding-block: 30px;
//   justify-content: center;
//   align-items: center;
// `;

// const NewRoute = styled.div`
//   position: absolute;
//   top: ${(props) => (props.$showNewRoute ? "110px" : "130px")};
//   right: 10px;
//   display: flex;

//   justify-content: center;
//   align-items: center;
//   z-index: 2;
//   box-shadow: 0 0 8px 2px rgba(0, 0, 0, 0.1);
//   width: 40px;
//   height: 40px;
//   background: #27aae1;
//   border-radius: 4px;
//   // box-shadow: 0 0 8px 2px rgba(0, 0, 0, 0.1);
//   &:hover {
//     background-color: #4bc7fa;
//   }
//   transition: all 0.5s ease;
// `;

// const NewRouteButton = styled.button`
//   border-radius: 12px;
//   background-color: #27aae1;
//   width: fit-content;
//   height: fit-content;
//   padding: 10px 16px;
//   color: #000;
//   font-weight: 500;
//   font-size: 16px;
//   line-height: 20px;
//   display: flex;
//   flex-direction: row;
//   align-items: center;
//   justify-content: center;
//   gap: 8px;
//   &:hover {
//     background-color: #4bc7fa;
//   }
//   transition: all 0.6s ease;
// `;
